import React, { useState } from 'react';
import 'iconify-icon';
import { toast } from 'sonner';

const ShareButtons = ({ url, title, description = '' }) => {
  const [copied, setCopied] = useState(false);
  const fullUrl = url.startsWith('http') ? url : window.location.origin + url;
  const text = encodeURIComponent(`${title}${description ? ' — ' + description : ''}`);
  const link = encodeURIComponent(fullUrl);

  const shares = [
    {
      key: 'whatsapp',
      icon: 'mdi:whatsapp',
      label: 'WhatsApp',
      href: `https://wa.me/?text=${text}%20${link}`,
      color: 'hover:bg-emerald-500 hover:text-white',
    },
    {
      key: 'twitter',
      icon: 'mdi:twitter',
      label: 'X / Twitter',
      href: `https://twitter.com/intent/tweet?text=${text}&url=${link}`,
      color: 'hover:bg-black hover:text-white',
    },
    {
      key: 'linkedin',
      icon: 'mdi:linkedin',
      label: 'LinkedIn',
      href: `https://www.linkedin.com/sharing/share-offsite/?url=${link}`,
      color: 'hover:bg-[#0a66c2] hover:text-white',
    },
    {
      key: 'facebook',
      icon: 'mdi:facebook',
      label: 'Facebook',
      href: `https://www.facebook.com/sharer/sharer.php?u=${link}`,
      color: 'hover:bg-[#1877f2] hover:text-white',
    },
  ];

  const copyLink = async () => {
    try {
      await navigator.clipboard.writeText(fullUrl);
      setCopied(true);
      toast.success('Link copiado!');
      setTimeout(() => setCopied(false), 2000);
    } catch {
      toast.error('Não foi possível copiar');
    }
  };

  return (
    <div className="flex items-center gap-2 flex-wrap" data-testid="share-buttons">
      <span className="text-xs font-mono uppercase tracking-widest text-neutral-500 mr-2">Compartilhar</span>
      {shares.map((s) => (
        <a
          key={s.key}
          href={s.href}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={`Compartilhar no ${s.label}`}
          data-testid={`share-${s.key}`}
          className={`w-10 h-10 rounded-full bg-neutral-100 text-neutral-600 flex items-center justify-center transition-all duration-300 transform hover:scale-110 ${s.color}`}
        >
          <iconify-icon icon={s.icon} className="text-xl"></iconify-icon>
        </a>
      ))}
      <button
        type="button"
        onClick={copyLink}
        aria-label="Copiar link"
        data-testid="share-copy"
        className="w-10 h-10 rounded-full bg-neutral-100 text-neutral-600 flex items-center justify-center transition-all duration-300 transform hover:scale-110 hover:bg-accent-orange hover:text-white"
      >
        <iconify-icon icon={copied ? 'solar:check-circle-bold' : 'solar:link-linear'} className="text-xl"></iconify-icon>
      </button>
    </div>
  );
};

export default ShareButtons;
